











import { Component, Prop, Vue } from 'vue-property-decorator';
import { mapState, mapGetters } from 'vuex';

import { Config } from '../models/config-viewmodel';
import { Study } from '../models/grade-viewmodels';

@Component({
    computed: {
        ...mapState(['activeStudy']),
        ...mapGetters(['noExcurStudy']),
        ...mapState(['config'])
    }
})
export default class SelectStudy extends Vue {
    @Prop() extraClass?: string;

    public selected: any = '';
    public activeStudy!: Study;
    public noExcurStudy!: Study[];
    public config!: Config;

    private setSelectStudy(): void {
        sessionStorage.setItem('setSelectedStudy', JSON.stringify(this.selected));
        this.$store.commit('setSelectedStudy', this.selected);

        if (this.config.vuNetIdStudent != this.config.vuNetIdUser)
            location.hash = `/vunetid=${this.config.vuNetIdStudent}&study=${this.selected.id}`;
        else
            location.hash = `/study=${this.selected.id}`;

        if (this.activeStudy.academicYears && this.activeStudy.academicYears[0]) {
            this.activeStudy.academicYears[0].isOpen = true;
        }
    }

    mounted() {
        try {
            let hash = window.location.hash.replace('#/', '');
            let match = hash.match(/study=([^&]+)/);  //Find the value for study from the hash string
            let studyId = match ? match[1] : null;

            let sessionStudy = sessionStorage.getItem('setSelectedStudy');

            if (studyId) {
                this.selected = this.noExcurStudy.find(study => study.id === studyId);
            }
            
            if (!this.selected && sessionStudy) {
                let sessionStudyJSON: Study = JSON.parse(sessionStudy);
                this.selected = this.noExcurStudy.find(study => study.id === sessionStudyJSON.id)
            }
        } catch (err) {
            console.log('Error loading stud choice by session storage')
        }

        this.selected = this.selected || this.noExcurStudy[0];
        this.setSelectStudy();
    }
}
